import * as SettingsActionTypes from 'actiontypes/settings';
import SettingsService from 'services/SettingsService';

const service = new SettingsService();

/** ----------------------------------------------------------------------------
 * Unlink Facebook/Twitter Account
 -----------------------------------------------------------------------------*/

export const unlinkSocialAccountRequested = () => ({
  type: SettingsActionTypes.UNLINK_SOCIAL_ACCOUNT_REQUESTED,
  isUnlinking: true,
});

export const unlinkSocialAccountSuccess = (response, account) => ({
  type: SettingsActionTypes.UNLINK_SOCIAL_ACCOUNT_SUCCESS,
  isUnlinking: false,
  isSuccess: response.isSuccess,
  message: response.message,
  accountType: account,
});

export const unlinkSocialAccountFailure = error => ({
  type: SettingsActionTypes.UNLINK_SOCIAL_ACCOUNT_FAILURE,
  isUnlinking: false,
  error: true,
  status: error.response && error.response.status,
});

export default function unlinkSocialAccount(account) {
  return (dispatch) => {
    dispatch(unlinkSocialAccountRequested(account));

    if (account === 'twitter') {
      return service.unlinkTwitter(account).then(
        response => dispatch(unlinkSocialAccountSuccess(response.data, account)),
        error => dispatch(unlinkSocialAccountFailure(error, account)),
      );
    }
    if (account === 'facebook') {
      return service.unlinkFacebook(account).then(
        response => dispatch(unlinkSocialAccountSuccess(response.data, account)),
        error => dispatch(unlinkSocialAccountFailure(error, account)),
      );
    }

    return undefined;
  };
}